'use strict';
const angular = require('angular');

const uiRouter = require('angular-ui-router');

import routes from './violations-code-edit.routes';

export class ViolationsCodeEditComponent {
  constructor(Auth, $state, $stateParams, dialogs, ViolationCodesService, TemplateService, $uibModal, $timeout) {
    'ngInject';

    this.codeId = $stateParams.id;

    this.dialogs = dialogs;
    this.$uibModal = $uibModal;
    this.ViolationCodesService = ViolationCodesService;
    this.TemplateService = TemplateService;
    this.Auth = Auth;

    this.jsonValue = "";
    this.$state = $state;
    this.$timeout = $timeout;

    this.toolbarDefinition = [
      ["bold","italics","underline"],
      ["h3","h4","h5"],
      ["p","quote","clear"],
      ["ul","ol"],
      ["justifyLeft","justifyCenter","justifyRight","justifyFull"],
      ["undo","redo"]/*,
      ["backgroundColor","fontColor","fontName", "fontSize"]*/
    ];

    this.TemplateService.query(data => {
      this.templates = data;
    });

    this.model = {
      sequence: [{
        fee: 0
      }]
    };

    if (this.codeId) {
      this.ViolationCodesService.get({id: this.codeId}, data => {
        this.model = data;
        this.$timeout(_=>{
          this.active=0
        }, 0);
      }, err => {
        console.log('Could not load violation code from server');
      })
    }
  }

  removeLevel(idx) {
    this.model.sequence.splice(idx, 1);
  }

  addLevel() {
    this.model.sequence.push({fee: 0});
  }

  templateLookup(idx) {
    var that = this;

    var modalInstance = this.$uibModal.open({
      animation: true,
      component: 'templateLookup',
      resolve: {
        config: function() {
          return {}
        }
      },
      size: 'lg'
    });

    modalInstance.result.then(
      function (template) {
        that.model.sequence[idx].template = template._id;
      },
      function () { /* cancel */ }
    );

  }

  create(form) {
    this.submitted = true;
    this.sendFailure = false;

    var that = this;

    if (form.$valid) {

      var onSuccess = () => {
        var actionString = (this.codeId) ? "changed" : "created";
        var dlg = this.dialogs.notify("Success", "The violation code has been "+actionString+" successfully");
        dlg.result.then(() => {
          that.$state.go("violation-code-list");
        });
      };

      var onError = err => {
        this.sendFailure = true;
      };

      if (this.codeId) {  // Save changes on the current settings
        this.ViolationCodesService.update({id: this.codeId}, this.model, onSuccess, onError);
      } else { // Create new settings
        this.model.meta = {creationUser: this.Auth.getCurrentUserSync()._id};
        this.ViolationCodesService.save(this.model, onSuccess, onError);
      }
    }
  }
}

export default angular.module('conduu.violationsCodeEdit', [uiRouter])
  .config(routes)
  .component('violationsCodeEdit', {
    template: require('./violations-code-edit.html'),
    controller: ViolationsCodeEditComponent,
    controllerAs: 'ctrl'
  })
  .name;



// WEBPACK FOOTER //
// ./client/app/violations/code-edit/violations-code-edit.component.js